const hasNavigator = typeof navigator !== 'undefined';

export const isAndroid = () => hasNavigator && /Android/.test(navigator.userAgent);
export const isIOS = () => hasNavigator && (
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2)
);

export const isMobile = (() => hasNavigator ? !!navigator.userAgent && (isIOS() || isAndroid()) : false)();